export { default } from './MediaLightbox';
export type { LightboxItem } from './MediaLightbox';
